
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#478FFF","d":"M8.266 12.89l4.625-4.64a.372.372 0 000-.528l-.222-.222a.375.375 0 00-.531 0L8.53 11.122V1.375A.376.376 0 008.156 1h-.312a.376.376 0 00-.375.375v9.747L3.862 7.497a.375.375 0 00-.53 0l-.223.222a.375.375 0 000 .531l4.625 4.64a.375.375 0 00.532 0zM13.625 15a.376.376 0 00.375-.375v-.25a.376.376 0 00-.375-.375H2.375a.376.376 0 00-.375.375v.25c0 .206.169.375.375.375h11.25z"}})])
          )
        }
      }
    